<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 py-1 border-b-2 border-gray-200" v-for="(person, idx) in persons" :key="idx">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4 mt-1">
            <div class="col-span-12">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs"
                    :class="(person.entityType === 'CORPORATE') ? 'bg-primary' : 'bg-orange'">
                {{ (person.entityType === 'CORPORATE') ? '#CorporateEntity' : '#Individual' }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="person.entityType === 'CORPORATE' && person.corporate">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.registeredName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.brn"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.primaryEmail"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.primaryPhone"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.dateOfIncorporation"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.subType ? cleanEntityType(person.corporate.subType) : ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.countryOfOrigin"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.corporate.addressInCountryOfIncorporation"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  rows="4"
                  disabled="true"
                  :value="person.corporate.registeredAddress?.postalAddress || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredAddress?.plot" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  rows="4"
                  disabled="true"
                  :value="person.corporate.registeredAddress.plot"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredAddress?.street" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  rows="4"
                  disabled="true"
                  :value="person.corporate.registeredAddress.street"
                  required>
                </input>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="person.entityType === 'INDIVIDUAL' && person.individual">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.givenName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.middleName" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.middleName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.surName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus text-capitalize"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.idType?.toLowerCase() || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.idNumber"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.nationality"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.email"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.phoneNumber"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.sex" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus text-capitalize"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.sex.toLowerCase()"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.dateOfBirth ? dateFormat(person.individual.dateOfBirth) : ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.occupation"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.individual.physicalAddress?.district?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.individual.physicalAddress?.region?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.individual.physicalAddress?.subcounty?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.individual.physicalAddress?.parish?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.individual.physicalAddress?.village?.name || ''"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.postalAddress"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.street"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.individual.plotNumber"
                  required>
                </input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { dateFormat } from "@/commons/composables/utilities";
import { Corporate, Individual } from "@/types";

interface Person {
  entityType: string
  corporate?: Corporate
  individual?: Individual
}

interface Props {
  corporates: Corporate[]
  individuals: Individual[]
}

const props = defineProps<Props>()

const persons = ref<Person[]>([])

onMounted(() => {
  for (let i = 0; i < props.individuals.length; i++) {
    persons.value.push({
      entityType: "INDIVIDUAL",
      individual: props.individuals[i]
    })
  }

  for (let i = 0; i < props.corporates.length; i++) {
    persons.value.push({
      entityType: "CORPORATE",
      corporate: props.corporates[i]
    })
  }
})

const cleanEntityType = (name: string) => {
  let n = name.replaceAll("-", " ")
  return n.charAt(0).toUpperCase() + n.slice(1)
}
</script>
